export function mergeArray(objValue, srcValue) {
  if (Array.isArray(objValue)) {
    return [...objValue, ...srcValue]
  }
}

export default mergeArray
